import React from "react";
import SectionCard from "../components/cards/SectionCard";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { content, language } from "../translation/Translate";
import { useFETCH } from "../Tools/APIs";
import CardSkeleton from "../components/skeletons/CardSkeleton";

function Sections() {
  const location = useLocation();
  const { data, isLoading } = useFETCH("sections");

  return (
    <div className="px-2 sm:px-4 md:px-8 py-8 space-y-8">
      {location.pathname.includes("/brands") ? (
        <Outlet />
      ) : (
        <>
          <h2 className="text-center font-bold text-2xl md:text-3xl">
            {content.sections.title}
          </h2>
          <div className="grid gap-4 py-4 w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 md:gap-6">
            {!isLoading ? (
              data?.data?.length > 0 ? (
                data?.data?.map((section) => {
                  return <SectionCard cardDetails={section} />;
                })
              ) : (
                <div className="h-[60vh] col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4 w-full flex justify-center items-center text-center">
                  <p
                    dir="auto"
                    className="w-full text-xl font-bold text-center"
                  >
                    {language === "en"
                      ? "No sections available."
                      : "لا يوجد أقسام."}
                  </p>
                </div>
              )
            ) : (
              <>
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
                <CardSkeleton />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Sections;
